import "./Footer.scss";
import React from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo.webp";
import SocialMediaLinks from "../../otherComponents/SocialMediaLinks/SocialMediaLinks";

const Footer = () => {
  const contactInfo = [
    {
      title: "Contact Us",
      address:
        "We transform your spaces with quality and precision: experts in drywall, paint, and epoxy floors.",
      phone: "+1 406 946 2673",
      location: "Bozeman, Montana 59718",
      email: "Epoxy.drywall.andpaint@gmail.com",
    },
  ];

  const navigate = useNavigate();
  const navigateToSection = (section) => {
    navigate("/services");
    setTimeout(() => {
      document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
    }, 200); // Retraso para asegurar la carga de la página
  };
  const navigateToContact = (contact) => {
    navigate("/contact");
    window.scroll(0, 0);
  };
  return (
    <div className="Footer">
      <div className="contentItems">
        {/* <div className="crown">
          <div className="sectionTitle">
            <h3>Upgrade Your Floor</h3> <h2>Act smartly today!</h2>
          </div>
          <div className="section">
            <div className="option">
              <button onClick={() => navigateToContact("contact")}>
                Find A Location
              </button>
            </div>
          </div>
        </div> */}
      </div>
      <div className="container-footer">
        <div className="footer-section address">
          <h3>Wise Coatings</h3>

          {contactInfo.map((info, index) => (
            <div className="item" key={index}>
              <h4>{info.title}</h4>
              <p>{info.address}</p>
              <ul className="nav">
                <li>
                  📞 Phone:{" "}
                  <a
                    href={`tel:${info.phone}`}
                    aria-label={`Call ${info.phone}`}
                  >
                    {info.phone}
                  </a>
                </li>
                <li>
                  📌 Location:
                  <a
                    href={`bingmaps:${info.location}`}
                    aria-label={`Call ${info.location}`}
                  >
                    {" "}
                    {info.location}
                  </a>
                </li>
                <li>
                  ✉️ Email:
                  <a
                    href={`mailto:${info.email}`}
                    aria-label={`Call ${info.email}`}
                  >
                    {" "}
                    {info.email}
                  </a>
                </li>
              </ul>
            </div>
          ))}
        </div>

        <div className="footer-section services">
          <h3>Services</h3>
          <ul className="nav">
            <li>
              <i aria-hidden="true" className="fas fa-angle-double-right"></i>
              <button onClick={() => navigateToSection("CEF")}>
                Epoxy floor
              </button>
            </li>
            <li>
              <i aria-hidden="true" className="fas fa-angle-double-right"></i>
              <button onClick={() => navigateToSection("DW")}>Drywall</button>
            </li>
            <li>
              <i aria-hidden="true" className="fas fa-angle-double-right"></i>
              <button onClick={() => navigateToSection("Pix")}>Paint</button>
            </li>
          </ul>
        </div>
        <div className="footer-section Quicklinks">
          <h3>Quicklinks</h3>
          <ul className="nav">
            <li>
              <i aria-hidden="true" className="fas fa-angle-double-right"></i>
              <Link to="/">Home</Link>
            </li>
            <li>
              <i aria-hidden="true" className="fas fa-angle-double-right"></i>
              <Link to="/About">About</Link>
            </li>
            <li>
              <i aria-hidden="true" className="fas fa-angle-double-right"></i>
              <Link to="/services">Services</Link>
            </li>
            <li>
              <i aria-hidden="true" className="fas fa-angle-double-right"></i>
              <Link to="/contact">Contact Us</Link>
            </li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="content">
          <div className="bottom-section ">
            <div className="logo">
              <img src={logo} alt="logo" />
            </div>
          </div>
          <div className="bottom-section links">
            <p>
              2025 © Site Credits
              <a href="https://whistlecoding.com/">Whistle Coding</a>
            </p>
            <SocialMediaLinks />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
